import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Medal } from "lucide-react";

let cache = null;
const getMvp = () => (cache ||= api.get("/tvnet/streak/battle-mvp").then((r) => r.data.mvp).catch(() => null));

export const useBattleMvp = () => { const [m, setM] = useState(null); useEffect(() => { getMvp().then(setM); }, []); return m; };

export const MvpBadge = ({ userId, mvp }) => {
  const live = useBattleMvp();
  const m = mvp === undefined ? live : mvp;
  if (!m || (userId && m.user_id !== userId)) return null;
  return <span className="inline-flex items-center gap-0.5 text-[10px] font-bold px-1.5 py-0.5 rounded-full bg-violet-500/20 border border-violet-400/50 text-violet-200" title={`Battle MVP · ${m.days} watch-days for ${m.group} · badge lasts until the next battle ends`} data-testid={`mvp-badge-${userId || m.user_id}`}><Medal className="w-3 h-3" />MVP</span>;
};
